'use strict';

/* 
  AppDownload provides additional tracking functionality for Mobile App download links
*/
function AppDownload() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this._moneywiseCode = null;
  this._fintelConnectCode = null;

  this.el = {};
  this._classes = {
    ctaLinks: '.js--macta'
  };

  this.init = function () {
    this.el.downloadLinks = this.node.querySelectorAll(this._classes.ctaLinks);

    this._getData();
    this._addTracking();
  };

  this.initAllReady = function () {};

  this._getData = function () {
    // Read values in cookies
    this._moneywiseCode = Cookies.getJSON(PartnerAttributionSettings.moneywise.attribution_key);
    this._fintelConnectCode = Cookies.getJSON(PartnerAttributionSettings.fintel_connect.attribution_key);
  };

  this._addTracking = function () {
    var _additionalTrackingString = '';

    // add partner attribution data to app download links if cookie exists:
    // Note: "?tracking=..." already exists on these links so we can safely append "&..." to them
    if (this._moneywiseCode || this._fintelConnectCode) {
      if (this._moneywiseCode) {
        _additionalTrackingString += '&' + PartnerAttributionSettings.moneywise.attribution_key + '=' + this._moneywiseCode;
      }
      if (this._fintelConnectCode) {
        _additionalTrackingString += '&' + PartnerAttributionSettings.fintel_connect.attribution_key + '=' + this._fintelConnectCode;
      }

      this.el.downloadLinks.forEach(function (link) {
        link.href += _additionalTrackingString;
      });
    }
  };
}